<template>
  <b-row class="featured-post pb-5">
    <b-col lg="7" md="12">
      <router-link
        class="featured__img-wrapper w-inline-block"
        :to="{
          name: 'BlogEntry',
          params: { slug: post.slug }
        }"
      >
        <b-img
          :src="require(`@/assets/img/blog/${post.coverImage}`)"
          :alt="post.title"
          class="featured__img"
        />
      </router-link>
    </b-col>

    <b-col lg="5" md="12" class="featured__text-wrapper">
      <BlogPostInfo :category="post.category" :date="post.date" />
      <router-link
        class="title__wrapper w-inline-block"
        :to="{
          name: 'BlogEntry',
          params: { slug: post.slug }
        }"
      >
        <h2 class="features__post-title">
          {{ post.title }}
        </h2>
      </router-link>
      <div class="features__post-description">
        {{ post.description }}
      </div>
    </b-col>
  </b-row>
</template>

<script>
import BlogPostInfo from "@/components/blog/BlogPostInfo.vue";

export default {
  components: {
    BlogPostInfo
  },

  props: {
    post: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Josefin+Sans:300,400,700&display=swap");
@import "~@/styles/_colour-palette.scss";

.blog-container {
  font-family: "Josefin Sans", arial, sans-serif;
  font-weight: 300;
  font-size: 18px;
  color: #6c757d;

  .inner-container {
    padding-right: 0;
    padding-left: 0;
  }

  a {
    transition: 0.3s all ease;
    text-decoration: none;
    color: $primary-blue;
  }

  a:hover {
    text-decoration: none;
    color: darken($primary-accent, 10%);
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-family: "Josefin Sans", arial, sans-serif;
  }
}

.features__post-title {
  margin-top: 8px;
  font-size: 28px;
  line-height: 38px;
  font-weight: 400;
}

.posts__info {
  display: flex;
  margin-top: 12px;
  margin-bottom: 5px;
  align-items: center;

  .info-text.category {
    color: #5b6066;
    font-size: 12px;
    line-height: 22px;
    font-weight: 700;
    letter-spacing: normal;
    text-transform: uppercase;
    cursor: default;
  }

  .info-divider {
    width: 4px;
    height: 4px;
    margin-right: 6px;
    margin-left: 6px;
    border-radius: 12px;
    background-color: #5b6066;
    color: #5b6066;
  }

  .info-text {
    color: #5b6066;
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    text-decoration: none;
    text-transform: capitalize;
  }
}
.featured-post {
  .posts__info {
    margin-top: 0;
  }

  .featured__img-wrapper {
    position: relative;
    z-index: 2;
    overflow: hidden;
    width: 751px;
    height: 405px;
    max-height: 405px;
    max-width: 751px;
    min-height: 405px;
    min-width: 751px;
    margin-top: 14px;
    padding-top: 0px;
    border-radius: 6px;
    object-fit: none;

    @media (max-width: 767px) {
      max-height: 181px;
      min-height: 181px;
    }

    @media (max-width: 991px) {
      max-width: 100%;
      min-width: 100%;
    }

    .featured__img {
      position: relative;
      z-index: 1;
      max-height: 100%;
      max-width: 100%;
      min-height: 100%;
      min-width: 100%;
      -webkit-transition: opacity 200ms ease;
      transition: opacity 200ms ease;
      object-fit: cover;

      @media (max-width: 767px) {
        max-height: 181px;
        min-width: 100%;
      }

      @media (max-width: 991px) {
        max-height: none;
        min-height: 300px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blog/BlogFeaturedPost.vue